import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "TextureItem" })
export default class TextureItem extends Vue {
    public localizer: any = Localizer;

    @Prop() readonly texture: any;
    @Prop() readonly template: string;
    @Prop() readonly isAuthenticated: boolean;
}